package com.ai.mitra.presentation.screens.mainscreen

import com.ai.mitra.domain.model.Group

data class GroupUiState(
    val data: List<Group> = emptyList()
)